export const SIMULATOR_ASSETS_NUMBER_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.Asset.SimulatorAssetsNumberComputed";
export const SIMULATOR_ASSETS_LOADED = "Charisma.Leasing.PublishedLanguage.Events.Asset.SimulatorAssetsLoaded";
export const GENERATE_SIMULATIONS_IN_MEMORY_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.GenerateSimulationsInMemoryCompleted";
export const KYC_SESSION_SCHEDULED = "Charisma.Leasing.PublishedLanguage.Events.Kyc.KycSessionScheduled";
export const OFFER_CREATED_EMAIL_NOTIFICATION =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferCreatedEmailNotification";
